import { render, staticRenderFns } from "./MyRoleDetails.vue?vue&type=template&id=78a26aa8&scoped=true"
import script from "./MyRoleDetails.vue?vue&type=script&lang=js"
export * from "./MyRoleDetails.vue?vue&type=script&lang=js"
import style0 from "./MyRoleDetails.vue?vue&type=style&index=0&id=78a26aa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a26aa8",
  null
  
)

export default component.exports